// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"72c70e5c","160":"0f4c32d1","208":"519a4511","293":"63dd6865","453":"8571af55","516":"53ab5076","519":"4647907e","917":"587e88dc","946":"135b0343"}[chunkId] + ".chunk.js";
};